import { render, staticRenderFns } from "./ImgPrivewDilog.vue?vue&type=template&id=18629900&scoped=true&"
import script from "./ImgPrivewDilog.vue?vue&type=script&lang=js&"
export * from "./ImgPrivewDilog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18629900",
  null
  
)

export default component.exports